
const AllProjects = [
    {
        id:"01",
        title:"EBazar",
        image:"../../../Assets/Projects/pAcademy.png",
        description:"This website appears to be an online marketplace for buying and selling various products such as electronics, fashion, and home goods. The website seems to have a modern design with clear navigation, search functionality, and product categories. However, as I am an AI language model and not a web browser, my analysis of the website is limited to what can be gathered from the website's public-facing pages.",
        Front:"https://github.com/iamrealfarhanbd/Ebazar",
        Back:"https://github.com/iamrealfarhanbd/Ebazar",
        Web:"https://ebazar.onrender.com/"
    },
    {
        id:"02",
        title:"Ebazar Warehouse",
        image:"../../../Assets/Projects/ToolShop.png",
        description:"This is a full-stack Warehouse Management Website Login/Registration & Social Authentication. Users Can Create,Read, Update and Delete Products. User dashboard available. Details page User can Update or Deliver  Product Quantity",
        Front:"https://github.com/iamrealfarhanbd/Ebazar-WareHouse-Server",
        Back:"https://github.com/iamrealfarhanbd/Ebazar-WareHouse-Client",
        Web:"https://ebazar-warehouse.onrender.com/"
    },
    {
        id:"03",
        title:"ToolShop",
        image:"../../../Assets/Projects/Ebazar.png",
        description:"This is a full-stack Tools Manufacturer Website. Login/Registration and Social Authentication. Admin can manage orders, Tools, add User Role Users can manage user order and Profile. Admin Dashboard available. user dashboard available. Payment system added",
        Front:"https://github.com/iamrealfarhanbd/ToolShop-Server",
        Back:"https://github.com/iamrealfarhanbd/ToolShop-Client",
        Web:"https://toolshop.onrender.com/"
    }
]

export default AllProjects;